import { useState } from "react";
import { FieldValues, SubmitErrorHandler, SubmitHandler } from "react-hook-form";
import { ZodSchema } from "zod";
import { sendWarningReport } from "../reporting";
import { isHttpError } from "v2/utils/ky";

export function useFormHandlers<TSchema extends FieldValues = FieldValues>({
  onSubmit,
  onInvalidSubmit = () => {},
}: {
  schema: ZodSchema<TSchema>;
  onSubmit: SubmitHandler<TSchema>;
  onInvalidSubmit?: SubmitErrorHandler<TSchema>;
}) {
  const [showError, setShowError] = useState<boolean>(false);
  function onSubmitHandler(onSubmit: SubmitHandler<TSchema>) {
    return async (data: TSchema) => {
      try {
        await onSubmit(data);
      } catch (error: any) {
        setShowError(true);
        if (isHttpError(error)) {
          const statusCode = error.response.status;
          if (statusCode !== 409) {
            sendWarningReport(
              `Request failed with status code ${statusCode} on ${error.response.url}`,
            );
          }
        } else {
          sendWarningReport(error);
        }
      }
    };
  }

  return {
    showError,
    onSubmit: onSubmitHandler(onSubmit),
    onInvalidSubmit,
  };
}
